import { createContext } from 'react';
/**
 * TitledContext is how Titled components track and update their parents.
 */
export const TitledContext = createContext(undefined);
